import React, { useState } from 'react';
import { Card, Table, Select, Row, Col, Statistic, Progress, Avatar, Tabs, Tag, Button, Space } from 'antd';
import { Line, Radar, Column } from '@ant-design/charts';
import { 
  TrophyOutlined, 
  RiseOutlined, 
  HeartOutlined, 
  UserOutlined,
  CalendarOutlined,
  FireOutlined,
  ThunderboltOutlined,
  AreaChartOutlined
} from '@ant-design/icons';

const { TabPane } = Tabs;

const Performance = () => {
  const [selectedAthlete, setSelectedAthlete] = useState('1');

  // Sporcu listesi - sadeleştirildi
  const athletes = [
    { id: '1', name: 'Ahmet Yılmaz', age: 22, branch: 'Futbol' },
    { id: '2', name: 'Mehmet Demir', age: 19, branch: 'Basketbol' },
    { id: '3', name: 'Ayşe Kaya', age: 20, branch: 'Voleybol' },
  ];

  const [performanceData] = useState([
    { date: '2024-01', score: 85, metric: 'Kondisyon' },
    { date: '2024-02', score: 88, metric: 'Kondisyon' },
    { date: '2024-03', score: 92, metric: 'Kondisyon' },
    { date: '2024-01', score: 75, metric: 'Kuvvet' },
    { date: '2024-02', score: 82, metric: 'Kuvvet' },
    { date: '2024-03', score: 87, metric: 'Kuvvet' },
    { date: '2024-01', score: 90, metric: 'Teknik' },
    { date: '2024-02', score: 92, metric: 'Teknik' },
    { date: '2024-03', score: 95, metric: 'Teknik' },
  ]);

  const [measurements] = useState([
    { id: 1, date: '2024-03-20', height: 175, weight: 70, bmi: 22.9, bodyFat: 15 },
    { id: 2, date: '2024-02-20', height: 175, weight: 71, bmi: 23.2, bodyFat: 16 },
  ]);

  const radarData = [
    { item: 'Kondisyon', value: 92 },
    { item: 'Kuvvet', value: 87 },
    { item: 'Teknik', value: 95 },
    { item: 'Çeviklik', value: 88 },
    { item: 'Dayanıklılık', value: 90 },
  ];

  const measurementColumns = [
    { title: 'Tarih', dataIndex: 'date', key: 'date' },
    { title: 'Boy (cm)', dataIndex: 'height', key: 'height' },
    { title: 'Kilo (kg)', dataIndex: 'weight', key: 'weight' },
    { title: 'VKİ', dataIndex: 'bmi', key: 'bmi' },
    { title: 'Vücut Yağ %', dataIndex: 'bodyFat', key: 'bodyFat' },
  ];

  const radarConfig = {
    data: radarData,
    xField: 'item',
    yField: 'value',
    meta: {
      value: {
        min: 0,
        max: 100,
      },
    },
    area: {
      style: {
        fill: '#5B8FF9',
        fillOpacity: 0.3,
      },
    },
  };

  // Yeni hedefler verisi
  const targets = [
    { title: 'Kilo Hedefi', current: 70, target: 68, deadline: '2024-05-01' },
    { title: 'Vücut Yağ Hedefi', current: 15, target: 12, deadline: '2024-06-01' },
    { title: 'Koşu Mesafesi', current: 8, target: 10, deadline: '2024-04-15', unit: 'km' },
  ];

  // Antrenman istatistikleri güncellendi
  const trainingStats = [
    { 
      date: '2024-03', 
      type: 'Antrenman Sayısı',
      value: 20
    },
    { 
      date: '2024-02', 
      type: 'Antrenman Sayısı',
      value: 18
    },
    { 
      date: '2024-01', 
      type: 'Antrenman Sayısı',
      value: 15
    },
    { 
      date: '2024-03', 
      type: 'Toplam Süre (saat)',
      value: 25
    },
    { 
      date: '2024-02', 
      type: 'Toplam Süre (saat)',
      value: 22
    },
    { 
      date: '2024-01', 
      type: 'Toplam Süre (saat)',
      value: 20
    }
  ];

  return (
    <div>
      <Card>
        <Row gutter={16} align="middle" style={{ marginBottom: 20 }}>
          <Col span={6}>
            <Select
              style={{ width: '100%' }}
              placeholder="Sporcu Seçiniz"
              value={selectedAthlete}
              onChange={setSelectedAthlete}
            >
              {athletes.map(athlete => (
                <Select.Option key={athlete.id} value={athlete.id}>
                  {athlete.name}
                </Select.Option>
              ))}
            </Select>
          </Col>
          <Col span={18}>
            <Space size="large" style={{ float: 'right' }}>
              <Button type="primary" icon={<CalendarOutlined />}>
                Antrenman Planla
              </Button>
              <Button icon={<AreaChartOutlined />}>
                Rapor Oluştur
              </Button>
            </Space>
          </Col>
        </Row>

        <Row gutter={16} style={{ marginBottom: 20 }}>
          <Col span={8}>
            <Card>
              <Statistic
                title="Genel Performans"
                value={92}
                prefix={<TrophyOutlined />}
                suffix="%"
                valueStyle={{ color: '#3f8600' }}
              />
              <Progress percent={92} status="active" />
            </Card>
          </Col>
          <Col span={8}>
            <Card>
              <Statistic
                title="Gelişim"
                value={15}
                prefix={<RiseOutlined />}
                suffix="%"
                valueStyle={{ color: '#cf1322' }}
              />
              <Progress percent={15} status="active" strokeColor="#cf1322" />
            </Card>
          </Col>
          <Col span={8}>
            <Card>
              <Statistic
                title="Kondisyon Durumu"
                value={88}
                prefix={<HeartOutlined />}
                suffix="%"
                valueStyle={{ color: '#1890ff' }}
              />
              <Progress percent={88} status="active" strokeColor="#1890ff" />
            </Card>
          </Col>
        </Row>

        <Tabs defaultActiveKey="1" style={{ marginTop: 20 }}>
          <TabPane tab="Performans Analizi" key="1">
            <Row gutter={16}>
              <Col span={12}>
                <Card title="Performans Gelişimi" extra={<Button type="link">Detaylı Analiz</Button>}>
                  <Line 
                    data={performanceData}
                    xField="date"
                    yField="score"
                    seriesField="metric"
                    smooth={true}
                    animation={{
                      appear: {
                        animation: 'path-in',
                        duration: 1000,
                      },
                    }}
                    style={{ height: 300 }}
                    theme={{ maxColumnWidth: 40 }}
                    tooltip={{
                      customContent: (title, items) => {
                        return (
                          <div style={{ padding: '10px' }}>
                            <div style={{ marginBottom: '5px' }}>{title}</div>
                            {items.map((item, index) => (
                              <div key={index} style={{ color: item.color }}>
                                {item.name}: {item.value}
                              </div>
                            ))}
                          </div>
                        );
                      },
                    }}
                  />
                </Card>
              </Col>
              <Col span={12}>
                <Card title="Yetenek Analizi" extra={<Button type="link">Detaylı Rapor</Button>}>
                  <Radar {...radarConfig} style={{ height: 300 }} />
                </Card>
              </Col>
            </Row>
          </TabPane>

          <TabPane tab="Hedefler ve İlerleme" key="2">
            <Row gutter={16}>
              {targets.map((target, index) => (
                <Col span={8} key={index}>
                  <Card>
                    <Statistic
                      title={target.title}
                      value={((target.current / target.target) * 100).toFixed(1)}
                      suffix="%"
                      prefix={<FireOutlined />}
                    />
                    <Progress
                      percent={((target.current / target.target) * 100)}
                      status="active"
                      strokeColor={{
                        '0%': '#108ee9',
                        '100%': '#87d068',
                      }}
                    />
                    <div style={{ marginTop: 10 }}>
                      <Tag color="blue">
                        Hedef: {target.target} {target.unit}
                      </Tag>
                      <Tag color="orange">
                        <CalendarOutlined /> {target.deadline}
                      </Tag>
                    </div>
                  </Card>
                </Col>
              ))}
            </Row>
          </TabPane>

          <TabPane tab="Antrenman İstatistikleri" key="3">
            <Row gutter={16}>
              <Col span={24}>
                <Card title="Aylık Antrenman Özeti">
                  <Column
                    data={trainingStats}
                    xField="date"
                    yField="value"
                    seriesField="type"
                    isGroup={true}
                    columnStyle={{
                      radius: [20, 20, 0, 0],
                    }}
                    label={{
                      position: 'top',
                    }}
                    legend={{
                      position: 'top'
                    }}
                    yAxis={{
                      title: {
                        text: 'Değer',
                      },
                    }}
                    xAxis={{
                      title: {
                        text: 'Ay',
                      },
                    }}
                  />
                </Card>
              </Col>
            </Row>
          </TabPane>
        </Tabs>

        <Card title="Fiziksel Ölçümler" style={{ marginTop: 16 }}>
          <Table 
            columns={measurementColumns}
            dataSource={measurements}
            rowKey="id"
          />
        </Card>
      </Card>
    </div>
  );
};

export default Performance;